import { useEffect, useState } from "react";
import WorkspaceIcon from '../../../assets/images/svg-icons-material-io/workspaces_FILL0_wght400_GRAD0_opsz48.svg';
import MailboxIcon from '../../../assets/images/svg-icons-material-io/local_post_office_FILL0_wght400_GRAD0_opsz48.svg';
import MailFwdIcon from '../../../assets/images/svg-icons-material-io/forward_to_inbox_FILL0_wght400_GRAD0_opsz48.svg';
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";

const SubMenuModal = () => {
    const navigate = useNavigate();
    const [flag, setFlag] = useState(false);
    useEffect(() => {
        if (flag) {
            $("#UserReportSubMenu").modal("hide");
            navigate(flag, { replace: true })
        };
    }, [flag, navigate]);

    return   <div className="SubMenuModal">
        <div className="modal fade" data-backdrop="false" data-keyboard="false" tabIndex="-1" role="dialog" id="UserReportSubMenu" aria-labelledby="User Report Sub Menus">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="false">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body ctr animate slide delay-1">
                        {/*User Activity Reports Box*/}
                        {/*<Link to={'/user-activity'} className="btn btn-primary dash-box box-user-activity" title="User Activity Reports" alt="Navigate to user activity reports">*/}
                        <Link onClick={(el) => { setFlag("/user-activity"); }} className="btn btn-primary dash-box box-user-activity" title="User Activity Reports" alt="Navigate to user activity reports">
                            <div className="box-icon">
                                <img src={WorkspaceIcon} className="filter-white" alt="User Activity Icon" />
                            </div>
                            <div className="box-bottom">
                                <div className="title">User Activity</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                        {/*Delete Activity Reports Box*/}
                       {/* <Link to={'/delete-user-activity'} className="btn btn-primary dash-box box-delect-activity" title="Delete Activity Reports" alt="Navigate to delete activity reports">*/}
                        <Link onClick={(el) => { setFlag("/delete-user-activity"); }}  className="btn btn-primary dash-box box-delect-activity" title="Delete Activity Reports" alt="Navigate to delete activity reports">
                            <div className="box-icon">
                                <i className="bi bi-trash" alt="Trash Icon"></i>
                            </div>
                            <div className="box-bottom">
                                <div className="title">Delete Activity</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                        {/*Mailbox Sizes Reports Box*/}
                        <Link onClick={(el) => { setFlag("/mailbox-size"); }} className="btn btn-primary dash-box box-mailbox" title="Mailbox Size Report" alt="Navigate to mailbox sizes reports" >
                            <div className="box-icon">
                                <img src={MailboxIcon} className="filter-white" alt="Mailbox sizes Icon" />
                            </div>
                            <div className="box-bottom">
                                <div className="title">Mailbox Sizes</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link >
                        {/*User Status Reports Box*/}
                        <Link onClick={(el) => { setFlag("/user-status"); }}  className="btn btn-primary dash-box box-userstatus" title="User Status Reports" alt="Navigate to user status reports" >
                            <div className="box-icon">
                                <i className="bi bi-clipboard2-data" alt="User Status Icon"></i>
                            </div>
                            <div className="box-bottom">
                                <div className="title">User Status</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link >
                        {/*Message Forwarding Reports Box*/}
                        <Link onClick={(el) => { setFlag("/message-forwarding"); }}  className="btn btn-primary dash-box box-msgfwd" title="Message Forwarding Reports" alt="Navigate to message forwarding reports">
                            <div className="box-icon">
                                <img src={MailFwdIcon} className="filter-white" alt="Message Forward Icon" />
                            </div>
                            <div className="box-bottom">
                                <div className="title">Message Forwarding</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                    </div >
                </div >
            </div >
        </div >
    </div>
};




export default SubMenuModal;